import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Functional component that initializes the footer of the form.
 *
 */
const KeyproFooter = () => {
    const { t } = useTranslation();
    const today = new Date();

    return (
        <Fragment>
            <footer className="container key-footer-container">
                <div className="login-footer">
                    &copy;&nbsp;2009-{today.getFullYear()}&nbsp;
                    <a href="http://www.keypro.fi" target="blank">
                        Keypro Oy
                    </a>
                </div>
                <div className="login-footer-warning">{t('unAuthFooter')}</div>
            </footer>
        </Fragment>
    );
};

export default KeyproFooter;
